<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Project Table Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <b-tabs card>
      <b-tab title="Submissions" active>
        <h3>
          <i :class="`fal fa-${submission_icon}`" /> Submissions
          <router-link
            class="btn btn-success float-right"
            :to="`/submissions/add/${project_id}/1`"
          >
            <i class="fal fa-plus" />
          </router-link>
        </h3>
        <submission-server-table
          :analytes="analyte_collection"
          :sample_types="sample_type_collection"
          :test_packages="test_package_collection"
          :show_columns="submission_columns"
        />
      </b-tab>
      <b-tab title="Samples" active>
        <h3>
          <i :class="`fal fa-${sample_icon}`" /> Samples
        </h3>
        <sample-server-table
          :analytes="analyte_collection"
          :sample_types="sample_type_collection"
          :test_packages="test_package_collection"
          :show_columns="sample_columns"
        />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import SampleServerTable from "@/components/lab/sample/SampleServerTable";
import SubmissionServerTable from "@/components/lab/submission/SubmissionServerTable";
import SampleModel from "@/models/lab/SampleModel";
import SubmissionModel from "@/models/lab/SubmissionModel";
import { getCollection } from "@/shared/fetch-utils";

export default {
  name: "ProjectDetailCardstack",
  components: {
    SampleServerTable,
    SubmissionServerTable
  },
  data() {
    return {
      loading: true,
      project_id: this.$route.params.project_id || null,
      analyte_collection: null,
      sample_type_collection: null,
      test_package_collection: null,
      submission_columns: [
        "pid",
        "created_at",
        "event_code",
        "sample_type.name",
        "test_package.name",
        "sample_count",
        "attribute_1",
        "attribute_2",
        "attribute_3",
        "received_percent",
        "prepped_percent",
        "scheduled_percent",
        "results_percent"
      ],
      sample_columns: [
        "pid",
        "created_at",
        "receiving_id",
        "submission.pid",
        "identifier",
        "number",
        "received",
        "prepped",
        "scheduled",
        "attribute_1",
        "attribute_2",
        "attribute_3",
        "actions"
      ]
    };
  },
  computed: {
    submission_icon() {
      return new SubmissionModel().icon();
    },
    sample_icon() {
      return new SampleModel().icon();
    }
  },
  methods: {
    async init() {
      const payload = {
        sort: [
          {
            logic: "sortAddAsc",
            field: "name"
          }
        ],
        limit: "all",
        message: this.$bvToast
      };

      this.analyte_collection = await getCollection({
        ...payload,
        collection_type: "analyte"
      });
      this.sample_type_collection = await getCollection({
        ...payload,
        collection_type: "sample_type"
      });
      this.test_package_collection = await getCollection({
        ...payload,
        collection_type: "test_package"
      });

      this.loading = false;
    }
  },
  created() {
    this.loading = true;

    this.init();
  }
};
</script>
